var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2236 10.7219C20.2236 13.1954 18.2793 15.1758 15.9111 15.1758C13.5429 15.1758 11.5986 13.1954 11.5986 10.7219C11.5986 8.24838 13.5429 6.26807 15.9111 6.26807C18.2793 6.26807 20.2236 8.24838 20.2236 10.7219Z",
    stroke: "#1E2023"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9111 15.2812C20.1781 15.2812 23.6239 18.6851 23.6239 22.8678C23.6239 23.2547 23.4515 23.6185 23.0772 23.9675C22.6953 24.3234 22.122 24.6434 21.387 24.9099C19.9191 25.442 17.9281 25.7173 15.9111 25.7173C13.894 25.7173 11.903 25.442 10.4352 24.9099C9.70018 24.6434 9.1268 24.3234 8.74497 23.9675C8.37068 23.6185 8.19824 23.2547 8.19824 22.8678C8.19824 18.6851 11.6441 15.2812 15.9111 15.2812Z",
    fill: "#1E2023",
    fillOpacity: 0.1,
    stroke: "#1E2023"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.3926873939cafa154fabf55abbdf214e.svg";
export { ForwardRef as ReactComponent };